<div class="side-table-container">
    <table id="blip-channel-main-table" class="side-table">
        <thead class="side-table__head">
            <tr>
                <th class="first-column-head">
                    Tipos de conteúdos  
                </th>
            </tr>
        </thead>
        <tbody class="side-table__body">
            { #each Object.entries(contentTypes) as [content, value] }
            <tr>
                <td class="first-column-content">
                    <p class="content-title">
                        {value.name}
                    </p>
                </td>
            </tr>
            { /each }
        </tbody>
    </table>
</div>
